import type {
  GetCaseByIdNormalized,
  GetCreatedCase,
  GetServiceNormalized,
} from '@messenger/types'

import { caseDates } from '@/mocks/dates/caseDates'

import { calculateCaseAge } from '@/utils/sanitizers/calculateCaseAge'
import { convertObjectOfDates } from '@/utils/dates/convertObjectOfDates'
import { isoStringToDate } from '@/utils/dates/isoStringToDate'

export const sanitizeCaseDates = <
  T extends GetCaseByIdNormalized | GetCreatedCase,
>(
  originalCase: T,
): T => {
  const _case = JSON.parse(JSON.stringify(originalCase))

  // calculate the ages, and add it to the case object
  calculateCaseAge(_case)

  // convert all dates in the case object
  convertObjectOfDates(caseDates.case, _case, isoStringToDate)

  // convert all dates in the case's service array
  _case?.services?.forEach((service: GetServiceNormalized) =>
    convertObjectOfDates(caseDates.service, service, isoStringToDate),
  )

  return _case
}

export default sanitizeCaseDates
